import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

export default function createApolloClient() {
  const uri = process.env.API_PUBLIC_URL.endsWith('/')
    ? `${process.env.API_PUBLIC_URL}graphql`
    : `${process.env.API_PUBLIC_URL}/graphql`;

  if (typeof window !== 'undefined') {
    console.log(`apollo client: ${uri}`);
  }

  const link = new HttpLink({
    // credentials: 'include',
    uri,
  });

  const cache = new InMemoryCache();

  const client = new ApolloClient({
    link,
    cache,
    ssrMode: typeof window === 'undefined',
  });

  return client;
}
